import React from 'react';
import { observer } from '../../shared/observer';
import {
  requiredClientFields,
  clientFieldErrors,
  clientFieldValues,
  clientInfoPatch,
} from '../../shared/clientFields';

// Окно «Укажите данные» после входа — как в приложении: если компания
// требует Ф/И/О или email (/cab/settings/new_mobile), а в карточке клиента их
// нет, сайт не пускает дальше, пока они не заполнены. Показывает только то, что
// компания требует. Компании с настройками по умолчанию его не видят.
class ClientInfoDialogView extends React.Component {
  state = { values: null, errors: {}, saving: false, error: null };

  // Нужное окно ещё не заполнено: берём значения из карточки клиента
  values() {
    return this.state.values || clientFieldValues(this.props.auth.clientInfo);
  }

  set = (k) => (e) => {
    const values = Object.assign({}, this.values(), { [k]: e.target.value });
    this.setState({ values, errors: Object.assign({}, this.state.errors, { [k]: null }) });
  };

  save = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (this.state.saving) return;
    const auth = this.props.auth;
    const values = this.values();
    const errors = clientFieldErrors(auth.companyInfo, values);
    if (Object.keys(errors).length) {
      this.setState({ errors });
      return;
    }
    this.setState({ saving: true, error: null });
    try {
      await auth.updateClientInfo(clientInfoPatch(values));
      this.setState({ saving: false, values: null });
    } catch (err) {
      this.setState({ saving: false, error: err.message || 'Не сохранилось. Попробуйте ещё раз.' });
    }
  };

  logout = (e) => {
    e.preventDefault();
    this.props.auth.logout();
  };

  field(label, k, type) {
    const err = this.state.errors[k];
    return (
      <div className="input" key={k}>
        <label>{label}</label>
        <input
          className={'input__text' + (err ? ' input__text--error' : '')}
          type={type || 'text'}
          value={this.values()[k]}
          onChange={this.set(k)}
          disabled={this.state.saving}
        />
        {err && <div className="ng-field-error">{err}</div>}
      </div>
    );
  }

  render() {
    const auth = this.props.auth;
    if (!auth.isAuthenticated) return null;
    const company = auth.companyInfo;
    const need = requiredClientFields(company);
    // окно нужно, пока в карточке нет требуемого
    if (!Object.keys(clientFieldErrors(company, clientFieldValues(auth.clientInfo))).length) return null;

    return (
      <div className="dialog">
        <div className="dialog__bg" />
        <form className="dialog__content" onSubmit={this.save}>
          <h2 className="h4">{company.mobile_user_hello_title || 'Укажите данные'}</h2>
          {company.mobile_user_info_text && <p>{company.mobile_user_info_text}</p>}

          {need.first && this.field('Имя', 'first')}
          {need.last && this.field('Фамилия', 'last')}
          {need.middle && this.field('Отчество', 'middle')}
          {need.middleOptional && this.field('Отчество (необязательно)', 'middle')}
          {need.email && this.field(company.mobile_email_title || 'Email', 'email', 'email')}

          {this.state.error && <div className="order-message">{this.state.error}</div>}

          <button
            type="submit"
            className={'btn btn--block' + (this.state.saving ? ' is-busy' : '')}
            disabled={this.state.saving}
          >
            {this.state.saving ? 'Сохраняем…' : 'Сохранить'}
          </button>
          {/* стиль здесь, а не в scss: у каждого шаблона семейства newgen свои стили */}
          <p style={{ margin: '16px 0 0', textAlign: 'center', fontSize: 13 }}>
            <a href="#" onClick={this.logout} style={{ color: 'inherit', opacity: 0.7 }}>Выйти из аккаунта</a>
          </p>
        </form>
      </div>
    );
  }
}

export const ClientInfoDialog = observer(ClientInfoDialogView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/ClientInfoDialog.jsx